<body class="background">
  <div class="container-fluid">
    <div class="row">
      
      <div class="col-lg-2"></div>
      <div class="col-lg-8 text-center">
        <div class="row">
          <div class="col-lg-12">
            <div class="logo" data-aos-easing="linear">
              <img
                src="{{ onPassiveBaseUrl }}onpassive(dec-6)/image/logo.png" alt="logo"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-2">
       
      </div>
      <!-------------second-section--------------------->
      <!------------------------------------------------>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-5 right">
        <div class="globe">
          <!-- <div class="globe">-->
          <img
            src="{{ onPassiveBaseUrl }}onpassive(dec-6)/image/logo-ball2.png"
            alt="logo-ball2"
            class="rotate globe-img"
          />
        </div>
        <div class="iconss">
          <ul>
            <li>
              <a
                href="https://www.facebook.com/ONPASSIVE/ONPASSIVE"
                target="_blank"
                rel="noopener"
                title="Facebook"
                ><i class="fa fa-facebook" aria-hidden="true"></i
              ></a>
            </li>
            <li>
              <a
                href="https://twitter.com/ONPASSIVE"
                target="_blank"
                rel="noopener"
                title="Twitter"
                ><i class="fa fa-twitter" aria-hidden="true"></i
              ></a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/c/ONPASSIVEc/ONPASSIVE"
                target="_blank"
                rel="noopener"
                title="Youtube"
                ><i class="fa fa-youtube" aria-hidden="true"></i
              ></a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/company/onpassiveofficial/company/onpassiveofficial"
                target="_blank"
                rel="noopener"
                title="LinkeIn"
                ><i class="fa fa-linkedin" aria-hidden="true"></i
              ></a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/ONPASSIVE/"
                target="_blank"
                rel="noopener"
                title="Instagram"
                ><i class="fa fa-instagram" aria-hidden="true"></i
              ></a>
            </li>
            <li>
              <a
                href="https://onpassive.com/blog"
                target="_blank"
                rel="noopener"
                title="ONPASSIVE Blog"
                ><i class="fa fa-clipboard" aria-hidden="true"></i
              ></a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-lg-2 right1">
        <div class="ecosystem">
        
          <h1 class="ml10 font12">
            <span class="text-wrapper">
              <span class="letters">Our Sophisticated </span>
              <span class="letters1">Marketing Tools</span>
            </span>
          </h1>
          <marquee direction="up" class="marquee1">
            <span>Domain Name</span>
            <span>Liquid Hosting</span>
            <span>Private Inbox </span>
            <span>VPN</span>
            <span>Video Email</span>
            <span>Website Builder</span>
            <span>Daily Funnel</span>
            <span>Office Abroad 1000</span>
            <span>ONPASSIVE Webinar</span>
            <span>TrimURL</span>
            <span>Crowdfunding </span>
            <span>Marketplace</span>
            <span>Multi-Businesses</span>
            <span>Millionaires Club </span>
            <span>Global Leaders</span>
            <span>Give Back</span>
            <span>AI GEO Testimonials</span>
            <span>Liquid Responsive Designs</span>
            <span>SEO</span>
            <span>Digital Marketing</span>
            <span>Mass Marketing Campaigns</span>
            <span>Guaranteed Targeted Visitors</span>
            <span>Mass Bulk Mailing </span>
            <span>Email Marketing </span>
            <span>Chat </span>
            <span>Video Conference</span>
            <span>Video Chat</span>
            <span>Flexible Wallets</span>
            <span>Staff Manager</span>
            <span>Video Marketing</span>
            <span>Screen Capture</span>
            <span>Support For All</span>
            <span>Payment Transfers</span>
            <span>Community</span>
            <span>Viral Sharing</span>
            <span>Contact Manager</span>
            <span>Live Events</span>
            <span>Calendar Scheduler </span>
            <span>SMS and MMS</span>
            <span>Print Shop</span>
            <span>Triple Entry Bonus</span>
            <span>Residual Income For Life</span>
            <span>Bonuses</span>
            <span>Merchants & Cards</span>
            <span>Legal & Compliance</span>
            <span>Advertising</span>
            <span>Artificial Intelligence AI</span>
            <span>Information Technology IT</span>
            <span>Digital Marketing DM</span>
            <span>IP Tracker</span>
          </marquee>
        </div>
      </div>
      <div class="col-lg-5 back">
        <div class="row">
          <div class="col-lg-12">
            <div class="content">
              
              <h3 class="content1">
                <p class="font14">
                  <marquee
                    >Why be average when you can be something more?</marquee
                  >
                </p>
                <p class="opportunities-text">
                  We at ONPASSIVE, create opportunities to redefine reality.
                  Understanding the current market scenarios, we combine AI and
                  marketing to make a difference in the field of digital
                  marketing. Join us and become a part of something
                  extraordinary.
                </p>
              </h3>
            </div>
            <div class="video-box">
              <video
                id="my-video"
                class="
                  video-js video-size
                  w-100
                  h-auto
                  my-video-dimensions
                  shadow
                "
                controls
                preload="auto"
                poster="{{ myLinksS3URL }}images/Image0231.png"
                data-setup="{}"
                autoplay="true"
                muted
              >
                <source
                  src="{{
                    myLinksS3URL
                  }}videos/Onpassive_launching_page_video2.mp4"
                  type="video/mp4"
                />
              </video>
            </div>
            <div class="btn new-btn">
              <a
                href="/registration/user?reg={{ userId }}"
                name="regform"
                class="animated-button1"
                target="_blank"
                rel="noopener"
              >
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                BECOME A FOUNDER NOW</a
              >
            </div>
            <div class="copy-right">
              <p></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</body>
